<div class="pay-method-dialog">
<h2 mat-dialog-title>Card details</h2>
<mat-dialog-content>
    <div class="row mb-3">
        <div class="form-group">
            <p class="text-muted text-sm mb-0">Card Number</p>
            <div class="col-md-12">
                <input type="text" class="form-control" aria-label="Card Number" appFormatCreditCard
                    placeholder="0000-0000-0000-0000" id="cardNumber" minlength="19" maxlength="19">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <p class="text-muted text-sm mb-0">Expiry Date</p>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <select class="form-select" aria-label="Card Expiry Month" [(ngModel)]="card.cardExpiryMonth">
                        <option selected value="0">Month</option>
                        <option value="{{month.month}}" *ngFor="let month of Months">{{month.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 mb-3">
                    <select class="form-select" aria-label="Card Expiry Year" [(ngModel)]="card.cardExpiryYear">
                        <option selected value="0">Year</option>
                        <option value="{{year}}" *ngFor="let year of Years">{{year}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <p class="text-muted text-sm mb-0">Card Holder Name</p>
            <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Card Holder Name" aria-label="Card Holder Name"
                    [(ngModel)]="card.cardHolderName" maxlength="200">
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button type="button" class="pay-dialog-btn pay-dialog-btn--ghost" mat-dialog-close>Cancel</button>
    <button type="button" class="pay-dialog-btn pay-dialog-btn--save" (click)="onAddUpdateCard()">Save</button>
</mat-dialog-actions>
</div>
